import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesForeignTradeTextWrapper = _resolveComponent("AnalyticsNotesForeignTradeTextWrapper")!

  return (_openBlock(), _createBlock(_component_AnalyticsNotesForeignTradeTextWrapper, {
    isLoading: _ctx.isTemplateDataLoading,
    isInitLoadedData: _ctx.isInitLoadedData
  }, _createSlots({ _: 2 }, [
    (_ctx.viewData)
      ? {
          name: "paragraph-0",
          fn: _withCtx(() => [
            _createTextVNode(" Внешнеторговый оборот России с " + _toDisplayString(_ctx.countryNameInstrumental) + " в " + _toDisplayString(_ctx.formatDisplayNumber(_ctx.viewData.endPeriodYear)) + " г., по данным российской таможенной статистики, составил " + _toDisplayString(_ctx.getMainTotalTradeSummaryText) + ", в том числе экспорт " + _toDisplayString(_ctx.getMainExportSummaryText) + ", а импорт " + _toDisplayString(_ctx.getMainImportSummaryText) + ". Данные за исключением продукции ТЭК (27 тов.гр.) составили: по товарообороту " + _toDisplayString(_ctx.getMainWithoutTekTotalTradeSummaryText) + ", по экспорту " + _toDisplayString(_ctx.getMainWithoutTekExportSummaryText) + ", сальдо " + _toDisplayString(_ctx.getMainBalanceSummaryText), 1)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.viewData)
      ? {
          name: "paragraph-1",
          fn: _withCtx(() => [
            _createTextVNode(" В " + _toDisplayString(_ctx.periodLabel) + " г. объем товарооборота " + _toDisplayString(_ctx.getCumTotalTradeSummaryText) + " Данные за исключением продукции ТЭК (27 тов.гр.) составили: по товарообороту " + _toDisplayString(_ctx.getCumWithoutTekTotalTradeSummaryText) + ", по экспорту " + _toDisplayString(_ctx.getCumWithoutTekExportSummaryText) + ", сальдо " + _toDisplayString(_ctx.getCumWithoutTekBalanceSummaryText) + " При этом объем российского экспорта " + _toDisplayString(_ctx.getCumExportSummaryText) + " Российский импорт " + _toDisplayString(_ctx.getCumImportSummaryText) + ". ", 1)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["isLoading", "isInitLoadedData"]))
}